import React from 'react';

export const sharedContext = React.createContext('');

export default sharedContext;